package fr.manyverse.app.domain.model

/**
 * Type of game event.
 */
enum class EventType {
    ANNOUNCEMENT,
    WHITEBOARD_OPENED,
    TIMER_STARTED,
    DIGICODE_LAUNCHED,
    LOCKPICKING_LAUNCHED,
    DICE_ROLLED,
    MESSAGE_SENT,
    PLAYER_JOINED,
    PLAYER_KICKED,
    PLAYER_ALERT,
    GM_ALERT,
    ANNOUNCEMENT_CANCELLED,
    COMBAT_STARTED,
    ITEM_SENT
}
